import { apiClient } from './auth';
import type { AppNotification, UnreadCountResponse } from '../types/notifications';

export interface GetNotificationsParams {
  before?: string;
  limit?: number;
  unread?: boolean;
}

export const getNotificationsApi = (params?: GetNotificationsParams) =>
  apiClient.get<{ notifications: AppNotification[]; hasMore: boolean }>('/notifications', { params });

export const getUnreadCountApi = () =>
  apiClient.get<UnreadCountResponse>('/notifications/unread-count');

export const markNotificationReadApi = (id: string) =>
  apiClient.patch<{ notification: AppNotification }>(`/notifications/${id}/read`);

export const markAllReadApi = () =>
  apiClient.patch<{ updated: number }>('/notifications/read-all');

export const dismissNotificationApi = (id: string) =>
  apiClient.delete<{ ok: boolean }>(`/notifications/${id}`);
